export default __webpack_public_path__ + "static/media/10.32c6c4cf.svg";